import { createContext, useCallback, useContext, useState, type ReactNode } from "react";
import { cn } from "@tarawa/ui";

type Kind = "success" | "error";
const Ctx = createContext<(message: string, kind?: Kind) => void>(() => {});

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<{ id: number; message: string; kind: Kind }[]>([]);
  const show = useCallback((message: string, kind: Kind = "success") => {
    const id = Date.now() + Math.random();
    setItems((p) => [...p.slice(-2), { id, message, kind }]);
    setTimeout(() => setItems((p) => p.filter((t) => t.id !== id)), 3500);
  }, []);
  return (
    <Ctx.Provider value={show}>
      {children}
      <div className="fixed inset-x-4 top-4 z-[100] flex flex-col items-center gap-2" aria-live="polite">
        {items.map((t) => (
          <div
            key={t.id}
            role={t.kind === "error" ? "alert" : "status"}
            className={cn("rounded-xl px-4 py-3 text-sm font-medium text-white shadow-lg", t.kind === "success" ? "bg-brand-900" : "bg-terracotta-600")}
          >
            {t.message}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}

export const useToast = () => useContext(Ctx);
